export default "__VITE_ASSET__27cedf61__"